import { render, staticRenderFns } from "./SummaryTable.vue?vue&type=template&id=53300a00"
import script from "./SummaryTable.vue?vue&type=script&lang=ts"
export * from "./SummaryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports